import { useEffect, useState, useRef } from "react";
import { getNotifications, readNotifications } from "../../lib/api";
import { useAuth } from "../../lib/AuthContext";
import { Bell, Heart, MessageCircle } from "lucide-react";

export const NotificationBell = () => {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const load = () => {
    getNotifications().then(({ data }) => { setItems(data.items); setUnread(data.unread); }).catch(() => {});
  };

  useEffect(() => {
    if (!user) return;
    load();
    const t = setInterval(load, 20000);
    return () => clearInterval(t);
  }, [user]);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  if (!user) return null;

  const toggle = async () => {
    const next = !open;
    setOpen(next);
    if (next && unread > 0) {
      await readNotifications().catch(() => {});
      setUnread(0);
    }
  };

  return (
    <div className="relative" ref={ref}>
      <button data-testid="nav-notifications" onClick={toggle}
        className="relative flex h-10 w-10 items-center justify-center rounded-full border border-blue-500/20 text-blue-100 transition-all duration-300 hover:bg-blue-500/10">
        <Bell size={16} />
        {unread > 0 && (
          <span data-testid="notif-unread" className="absolute -right-1 -top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-blue-500 px-1 font-mono text-[9px] text-white">{unread}</span>
        )}
      </button>
      {open && (
        <div data-testid="notif-dropdown" className="absolute right-0 top-12 z-50 max-h-96 w-80 overflow-y-auto rounded-2xl border border-blue-500/25 bg-[#0B1220]/95 p-2 backdrop-blur-2xl">
          {items.length === 0 && <p className="py-8 text-center font-mono text-[10px] uppercase tracking-[0.2em] text-[#405060]">Aucune notification</p>}
          {items.map((n) => (
            <div key={n.id} className={`flex items-start gap-3 rounded-xl p-3 ${n.read ? "" : "bg-blue-500/5"}`}>
              <span className="mt-0.5 text-blue-300">{n.type === "like" ? <Heart size={14} /> : <MessageCircle size={14} />}</span>
              <div>
                <p className="font-body text-xs text-[#CBD5E1]"><span className="text-white">{n.actor_name}</span> {n.text}</p>
                <p className="mt-0.5 font-mono text-[9px] uppercase tracking-[0.15em] text-[#405060]">{new Date(n.created_at).toLocaleString("fr-FR")}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
